import ListSelector, { defaultProps as listDefaultProps } from "./list-selector.component";
import RadioSelector, { defaultProps as radioDefaultProps } from "./radio-selector.component";
import ThresholdSelector, { defaultProps as thresholdDefaultProps } from "./threshold-selector/threshold-selector.component";
import ThresholdRangeSelector, { defaultProps as thresholdRangeDefaultProps } from "./threshold-range-selector/threshold-range-selector.component";
import DateSelector, { defaultProps as dateDefaultProps } from "./date-selector.component";
import DateRangeSelector, { defaultProps as dateRangeDefaultProps } from "./date-range-selector/date-range-selector.component";
import SelectSelector, { defaultProps as selectDefaultProps } from "./select-selector.component";
import TemporalSelector, { defaultProps as temporalDefaultProps } from "./temporal-selector.component";
import ToggleSelector, { defaultProps as toggleDefaultProps } from "./switch-selector.component";
import ChartYearSelector, { defaultProps as chartYearDefaultProps } from "./chart-year-selector.component";

const optionsSelectorInformation = {
  listSelector: {
    component: ListSelector,
    defaultProps: listDefaultProps
  },
  radioSelector: {
    component: RadioSelector,
    defaultProps: radioDefaultProps
  },
  thresholdSelector: {
    component: ThresholdSelector,
    defaultProps: thresholdDefaultProps
  },
  thresholdRangeSelector: {
    component: ThresholdRangeSelector,
    defaultProps: thresholdRangeDefaultProps
  },
  dateSelector: {
    component: DateSelector,
    defaultProps: dateDefaultProps
  },
  seasonBoundsSelector: {
    component: DateRangeSelector,
    defaultProps: dateRangeDefaultProps
  },
  selectSelector: {
    component: SelectSelector,
    defaultProps: selectDefaultProps
  },
  temporalSelector: {
    component: TemporalSelector,
    defaultProps: temporalDefaultProps
  },
  toggleSelector: {
    component: ToggleSelector,
    defaultProps: toggleDefaultProps
  },
  chartYearSelector: {
    component: ChartYearSelector,
    defaultProps: chartYearDefaultProps
  }
}

export default optionsSelectorInformation;